import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'PLANS/PLAN_SETTIONS';
export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(`${domain}/FETCH_ALL`, institutionId => ({institutionId}));

export const {action: showingInstitutionId} = createAction(`${domain}/SHOWING_INSTITUTION_ID`, institutionId => ({
    institutionId,
}));

export const {action: showManagePricingGroups} = createAction(`${domain}/SHOW_MANAGE_PRICING_GROUPS`, show => ({show}));
